import { Navigate, RouteObject } from 'react-router-dom'

import { analyticsTabs } from 'modules/Analytics/model/analyticsTabs'

import { AppInteractionLazy } from './routes/AppInteraction'
import { BranchLazy } from './routes/Branch'
import { DeliveryLazy } from './routes/Delivery'
import { FinancialMetricsLazy } from './routes/FinancialMetrics'
import { GCKLazy } from './routes/GCK'
import { GuestMetricsLazy } from './routes/GuestMetrics'
import { LoyaltyProgramsLazy } from './routes/LoyaltyPrograms'
import { MenuLazy } from './routes/Menu'
import { MenuMetricsLazy } from './routes/MenuMetrics'
import { SatisfactionLazy } from './routes/Satisfaction'
import AnalyticsWrapper from './ui/AnalyticsWrapper'

export const analyticsRoutes: RouteObject[] = [
  {
    path: 'analytics',
    element: <AnalyticsWrapper />,
    children: [
      {
        path: 'guest-metrics',
        element: <GuestMetricsLazy />,
      },
      {
        path: 'financial-metrics',
        element: <FinancialMetricsLazy />,
      },
      {
        path: 'menu-metrics',
        element: <MenuMetricsLazy />,
      },
      {
        path: 'loyalty-programs',
        element: <LoyaltyProgramsLazy />,
      },
      {
        path: 'gck',
        element: <GCKLazy />,
      },
      {
        path: 'delivery',
        element: <DeliveryLazy />,
      },
      {
        path: 'branch',
        element: <BranchLazy />,
      },
      {
        path: 'menu',
        element: <MenuLazy />,
      },
      {
        path: 'app-interaction',
        element: <AppInteractionLazy />,
      },
      {
        path: 'satisfaction',
        element: <SatisfactionLazy />,
      },
    ],
  },
  {
    path: 'analytics/',
    element: <Navigate to={analyticsTabs?.[0].key ?? ''} />,
  },
]
